<template>
  <div>
    <div class="pa-0 ma-0" style="background-color: white;">
      <NavBar styleType="finance"></NavBar>
      <div ref="videoContainerEmpty" id="videoContainerEmpty" class="pa-0 ma-0" :style="{ height: videoHeight + 'px' }">
        <div id="videoContent" class="pa-0 ma-0" :style="{ height: videoHeight + 'px' }">
          <div id="bkgrdVideoOverlay" :style="{ height: videoHeight + 'px' }"></div>
        </div>
      </div>
      <div class="body-overall page-top page-bottom fonts" style="color:black!important;">
            <v-row class="textPanel pb-8">
                <div class="container">
                  <v-row justify="start" class="pl-12 pr-12 hidden-xs" >
                    <v-col cols="6" class="pa-0 ma-0">                  
                      <h1 class="font2-heada" style="color:black!important;">TERMS & CONDITIONS</h1>
                    </v-col>
                    <v-col cols="6" justify="start" class="pa-0 ma-0">  
                      <v-row class="pl-6 pt-5">
                        <span class="mt-0 pb-0 mb-0 fonts-desc" style="color:black!important;">
                          Terms that govern use of 42Monks services for individuals and enterprise users.
                        </span>
                      </v-row>                
                    </v-col>
                  </v-row>
                  <v-row justify="start" class="pl-12 pr-12 hidden-sm-and-up pt-0 mt-0">
                        <h1 class="font2-head" style="color:black!important;">TERMS & CONDITIONS</h1>
                  </v-row>
                  <v-row justify="start" class="pl-12 pr-12 pt-4 pb-4 hidden-sm-and-up pt-0 mt-0">
                        <span class="mt-0 pb-0 mb-0 pl-0 fonts-desc" style="color:black!important;">
                          Terms that govern use of 42Monks services for individuals and enterprise users.
                        </span>
                  </v-row>  
                </div>
            </v-row>
            <v-row class="textPanel page-top pb-8">
                <div class="container">
                  <v-divider class="divider ml-9 mr-9 hidden-xs" style="color:black!important;"></v-divider>
                  <v-divider class="dividerxs ml-9 mr-9 hidden-sm-and-up" style="color:black!important;"></v-divider>
                </div>
            </v-row>
      </div>
      <div class="body-overall page-top page-bottom fonts" style="color:black!important;">
            <v-row class="textPanel pb-8">
                <div class="container">
                  <v-row justify="start" class="pl-12 pr-12 hidden-xs">
                    <v-col cols="6" class="pa-0 ma-0">                  
                      <h1 class="font2-heada" style="color:black!important;">Terms of use</h1>
                    </v-col>
                    <v-col cols="6" justify="start" class="pa-0 ma-0">  
                      <v-row class="pl-6 pt-5">
                        <span class="mt-0 pb-0 mb-0 fonts-desc" style="color:black!important;">
                          These Terms of Use apply to your use of Family Office and (office.42monks.com) and Wealth Management services (selene.42monks.com) and 42Monks other services, 
                          along with any associated software applications and websites (all together, “Services”). 
                          These Terms form an agreement between you and 42Monks company, and they include our 
                          Service Terms and important provisions for resolving disputes through arbitration. By using our Services, you agree to these Terms.                        
                        </span>
                      </v-row>                
                    </v-col>
                  </v-row>
                  <v-row justify="start" class="pl-12 pr-12 hidden-sm-and-up pt-0 mt-0">
                        <h1 class="font2-heada" style="color:black!important;">Terms of use</h1>
                  </v-row>
                  <v-row justify="start" class="pl-12 pr-12 pt-4 pb-4 hidden-sm-and-up pt-0 mt-0">
                        <span class="mt-0 pb-0 mb-0 pl-0 fonts-desc" style="color:black!important;">
                          These Terms of Use apply to your use of Family Office and (office.42monks.com) and Wealth Management services (selene.42monks.com) and 42Monks other services, 
                          along with any associated software applications and websites (all together, “Services”). 
                          These Terms form an agreement between you and 42Monks company, and they include our 
                          Service Terms and important provisions for resolving disputes through arbitration. By using our Services, you agree to these Terms.                             
                        </span>
                      </v-row>  
                </div>
            </v-row>
            <v-row class="textPanel page-top pb-8">
                <div class="container">
                  <v-row justify="start" class="pl-12 pr-12 pt-8 mt-0">
                        <span class="mt-0 pb-0 mb-0 pt-6 fonts-xsmall2" style="color:black!important;">
                          <b>Agreement and Acceptance.</b><br/>
                          This Terms & Conditions (“Terms & Conditions” or “Terms”) has been prepared by 42Monks Sp. z o.o. (Registered in Polish National Court Register)
(42Monks, “we”, “us”, “our” or “ours”). Prior to using https://42monks.com and all related subdomains (collectively, the “Website” or "Service" or "Services") of 42monks.com or desktop and/or mobile
applications, you (“user”, “you”, “your” or “yours”) confirm
acceptance of these Terms.<br/><br/>
                          <b>Registration and Access.</b><br/>
Minimum Age. You must be at least 18 years old or the minimum age required in your country to consent to use the Services.<br/>
<br/>
Registration. You must provide accurate and complete information to register for an account to use our Services. When applicable, you must provide us the information we need to comply with our obligations, including tax laws, regulations and other legal obligations.<br/>
You may not share your account credentials or make your account available to anyone else and are responsible for all activities that occur under your account. 
If you create an account or use the Services on behalf of another person or entity, you must have the authority to accept these Terms on their behalf.<br/><br/>
                          <b>What You Can Do.</b><br/>
                          Subject to your compliance with these Terms, you may access and use our Services. 
                          In using our Services, you must comply with all applicable laws as well as and any other documentation, guidelines, or policies we make available to you.<br/><br/>

<b>What You Cannot Do.</b> <br/>You may not use our Services for any illegal, harmful, or abusive activity. For example, you may not:<br/><br/>

&#x2022; Use our Services in a way that infringes, misappropriates or violates anyone’s rights.<br/>
&#x2022; Modify, copy, lease, sell or distribute any of our Services.<br/>
&#x2022; Attempt to or assist anyone to reverse engineer, decompile or discover the source code or underlying components of our Services, 
including our models, algorithms, or systems (except to the extent this restriction is prohibited by applicable law).<br/>
&#x2022; Automatically or programmatically extract data or Output (defined below).<br/>
&#x2022; Represent that Output was human-generated when it was not.<br/>
&#x2022; Interfere with or disrupt our Services, including circumvent any rate limits or restrictions or bypass any protective measures or safety mitigations we put on our Services.<br/>
&#x2022; Use Output to develop models that compete with 42Monks.<br/><br/>
<b>Software.</b><br/> Our software may include open source software that is governed by its own licenses that we’ve made available to you.<br/><br/>

<b>Third Party Services.</b><br/> Our services may include third party software, products, or services, (“Third Party Services”) and some parts of our Services. 
Third Party Services and Third Party Output are subject to their own terms, and we are not responsible for them. <br/><br/>

<b>Feedback.</b><br/> We appreciate your feedback, and you agree that we may use it without restriction or compensation to you.<br/><br/>

<b>Your Content.</b><br/> You may provide input to the Services (“Input”), and receive output from the Services based on the Input (“Output”). 
Input and Output are collectively “Content.” You are responsible for Content, including ensuring that it does not violate any applicable law or these Terms. 
You represent and warrant that you have all rights, licenses, and permissions needed to provide Input to our Services.<br/><br/>

<b>Ownership of Content.</b><br/> As between you and 42Monks, and to the extent permitted by applicable law, you (a) retain your ownership rights in Input and 
(b) own the Output. We hereby assign to you all our right, title, and interest, if any, in and to Output. <br/><br/>

<b>Similarity of Content.</b><br/> Due to the nature of our Services and artificial intelligence generally, output may not be unique and other users may receive similar output from our Services. 
Our assignment above does not extend to other users’ output or any Third Party Output. <br/><br/>

<b>Our Use of Content.</b><br/> We may use Content to provide, maintain, develop, and improve our Services, comply with applicable law, enforce our terms and policies, and keep our Services safe. <br/><br/>

<b>Accuracy.</b><br/> Artificial intelligence and machine learning are rapidly evolving fields of study. We are constantly working to improve our Services to make them more accurate, 
reliable, safe, and beneficial. Given the probabilistic nature of machine learning, use of our Services may, in some situations, result in Output that does not accurately reflect real people, places, or facts. 
<br/><br/>
When you use our Services you understand and agree:<br/><br/>

&#x2022; Output may not always be accurate. You should not rely on Output from our Services as a sole source of truth or factual information, or as a substitute for professional advice.<br/>
&#x2022; You must evaluate Output for accuracy and appropriateness for your use case, including using human review as appropriate, before using or sharing Output from the Services.<br/>
&#x2022; You must not use any Output relating to a person for any purpose that could have a legal or material impact on that person, such as making credit, educational, employment, housing, insurance, 
legal, medical, or other important decisions about them. <br/>
&#x2022; Our Services may provide incomplete, incorrect, or offensive Output that does not represent 42Monks views. 
If Output references any third party products or services, it doesn’t mean the third party endorses or is affiliated with 42Monks.<br/><br/>


<b>Billing.</b><br/> If you purchase any Services, you will provide complete and accurate billing information, including a valid payment method. 
For paid subscriptions, we will automatically charge your payment method on each agreed-upon periodic renewal until you cancel. 
You’re responsible for all applicable taxes, and we’ll charge tax when required. 
If your payment cannot be completed, we may downgrade your account or suspend your access to our Services until payment is received. <br/><br/>

<b>Service Credits.</b><br/> You can pay for some Services in advance by purchasing service credits. All service credits are subject to our Service Credit Terms.<br/><br/>

<b>Cancellation.</b><br/> You can cancel your paid subscription at any time. Payments are non-refundable, except where required by law. 
These Terms do not override any mandatory local laws regarding your cancellation rights.<br/><br/> 

<b>Changes.</b><br/> We may change our prices from time to time. If we increase our subscription prices, we will give you at least 30 days’ notice and any price increase will take effect 
on your next renewal so that you can cancel if you do not agree to the price increase.<br/><br/>

<b>Termination.</b><br/> You are free to stop using our Services at any time. We reserve the right to suspend or terminate your access to our Services or delete your account if we determine:<br/><br/>

&#x2022; You breached these Terms or our Usage Policies.<br/>
&#x2022; We must do so to comply with the law.<br/>
&#x2022; Your use of our Services could cause risk or harm to 42Monks, our users, or anyone else.<br/><br/>
We also may terminate your account if it has been inactive for over a year and you do not have a paid account. If we do, we will provide you with advance notice. We may decide to discontinue our Services, but if we do, we will give you advance notice.<br/><br/>

<b>Disclaimer of Warranties.</b><br/>
OUR SERVICES ARE PROVIDED “AS IS.” EXCEPT TO THE EXTENT PROHIBITED BY LAW, WE AND OUR AFFILIATES AND LICENSORS MAKE NO WARRANTIES (EXPRESS, IMPLIED, STATUTORY OR OTHERWISE) WITH RESPECT TO THE SERVICES, AND DISCLAIM ALL WARRANTIES INCLUDING, BUT NOT LIMITED TO, WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, 
SATISFACTORY QUALITY, NON-INFRINGEMENT, AND QUIET ENJOYMENT, AND ANY WARRANTIES ARISING OUT OF ANY COURSE OF DEALING OR TRADE USAGE. 
WE DO NOT WARRANT THAT THE SERVICES WILL BE UNINTERRUPTED, ACCURATE OR ERROR FREE, OR THAT ANY CONTENT WILL BE SECURE OR NOT LOST OR ALTERED. <br/>

YOU ACCEPT AND AGREE THAT ANY USE OF OUTPUTS FROM OUR SERVICE IS AT YOUR SOLE RISK AND YOU WILL NOT RELY ON OUTPUT AS A SOLE SOURCE OF TRUTH OR FACTUAL INFORMATION, OR AS A SUBSTITUTE FOR PROFESSIONAL ADVICE (Which we may also offer).<br/><br/>

<b>Limitation of Liability.</b><br/>
NEITHER WE NOR ANY OF OUR AFFILIATES OR LICENSORS WILL BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR EXEMPLARY DAMAGES, 
INCLUDING DAMAGES FOR LOSS OF PROFITS, GOODWILL, USE, OR DATA OR OTHER LOSSES, EVEN IF WE HAVE BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. 
OUR AGGREGATE LIABILITY UNDER THESE TERMS WILL NOT EXCEED THE GREATER OF THE AMOUNT YOU PAID FOR THE SERVICE THAT GAVE RISE TO THE CLAIM DURING 
THE 12 MONTHS BEFORE THE LIABILITY AROSE OR ONE HUNDRED EURO (€100). THE LIMITATIONS IN THIS SECTION APPLY ONLY TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW.<br/><br/>

Some countries and states do not allow the disclaimer of certain warranties or the limitation of certain damages, so some or all of the terms above may not apply to you, 
and you may have additional rights. In that case, these Terms only limit our responsibilities to the maximum extent permissible in your country of residence.<br/><br/>

42Monks AFFILIATES, SUPPLIERS, LICENSORS, AND DISTRIBUTORS ARE INTENDED THIRD PARTY BENEFICIARIES OF THIS SECTION.<br/><br/>

<b>Indemnity.</b><br/>
If you are a business or organization, to the extent permitted by law, you will indemnify and hold harmless us, our affiliates, and our personnel, 
from and against any costs, losses, liabilities, and expenses (including attorneys’ fees) from third party claims arising out of or relating 
to your use of the Services and Content or any violation of these Terms.<br/><br/>

<b>Assignment.</b><br/> 
You may not assign or transfer any rights or obligations under these Terms and any attempt to do so will be void.
We may assign our rights or obligations under these Terms to any affiliate, subsidiary, or successor in interest of any business associated with our Services.<br/><br/>

<b>Changes to These Terms or Our Services. </b>
<br/>We are continuously working to develop and improve our Services. 
We may update these Terms or our Services accordingly from time to time. For example, we may make changes to these Terms or the Services due to:<br/><br/>

&#x2022; Changes to the law or regulatory requirements.<br/>
&#x2022; Security or safety reasons.<br/>
&#x2022; Circumstances beyond our reasonable control.<br/>
&#x2022; Changes we make in the usual course of developing our Services.<br/>
&#x2022; To adapt to new technologies.<br/><br/>

We will give you at least 30 days advance notice of changes to these Terms that materially adversely impact you either via email or an in-product notification. 
All other changes will be effective as soon as we post them to our website. If you do not agree to the changes, you must stop using our Services.<br/><br/>

<b>Delay in Enforcing These Terms.</b><br/> 
Our failure to enforce a provision is not a waiver of our right to do so later. 
If any portion of these Terms is determined to be invalid or unenforceable, that portion will be enforced to the maximum extent permissible and it will not affect the enforceability of any other terms.<br/><br/>

                        </span>
                  </v-row>
                </div>
              </v-row>
            




            <v-row class="textPanel page-top pb-8">
                <div class="container">
                  <v-divider class="divider ml-9 mr-9 hidden-xs" style="color:black!important;"></v-divider>
                  <v-divider class="dividerxs ml-9 mr-9 hidden-sm-and-up" style="color:black!important;"></v-divider>
                </div>
            </v-row>
            <v-row class="textPanel pb-8">
                <div class="container">
                  <v-row justify="start" class="pl-12 pr-12 hidden-xs">
                    <v-col cols="6" class="pa-0 ma-0">                  
                      <h1 class="font2-heada" style="color:black!important;">Data processing</h1>
                    </v-col>
                    <v-col cols="6" justify="start" class="pa-0 ma-0">  
                      <v-row class="pl-6 pt-5">
                        <span class="mt-0 pb-0 mb-0 fonts-desc" style="color:black!important;">
                          This Data Processing Addendum (“DPA”) governs 42Monks processing of 
                          Customer Data (i) provided by Customer to 42Monks through 42Monks's API or any 42Monks services for businesses (“API Services”).     
                          or (ii) pursuant to 42Monks's provision of the Enterprise service for businesses (the "Enterprise Services”) 
                          (for purposes of this DPA, the API Services and Enterprise Services are together the “Services”). 
                        </span>
                      </v-row>          
                    </v-col>
                  </v-row>
                  <v-row justify="start" class="pl-12 pr-12 hidden-sm-and-up pt-0 mt-0">
                        <h1 class="font2-heada" style="color:black!important;">Data processing</h1>
                  </v-row>
                      <v-row justify="start" class="pl-12 pr-12 pt-4 pb-4 hidden-sm-and-up pt-0 mt-0">
                        <span class="mt-0 pb-0 mb-0 pl-0 fonts-desc" style="color:black!important;">
                          This Data Processing Addendum (“DPA”) governs 42Monks processing of 
                          Customer Data (i) provided by Customer to 42Monks through 42Monks API or any 42Monks services for businesses (“API Services”).     
                          or (ii) pursuant to 42Monks provision of the Enterprise service for businesses (the "Enterprise Services”) 
                          (for purposes of this DPA, the API Services and Enterprise Services are together the “Services”).             
                        </span>
                      </v-row>   
                </div>
            </v-row>
            <v-row class="textPanel page-top pb-8">
                <div class="container">
                  <v-row justify="start" class="pl-12 pr-12 pt-8 mt-0">
                        <span class="mt-0 pb-0 mb-0 pt-6 fonts-xsmall2" style="color:black!important;">
                          This Data Processing Addendum (“DPA”) governs 42Monks processing of Customer Data (i) provided by Customer to 42Monks through 42Monks API or any 42Monks services for businesses (“API Services”) 
                          or (ii) pursuant to 42Monks provision of the Enterprise service for businesses (the "Enterprise Services”) 
                          (for purposes of this DPA, the API Services and Enterprise Services are together the “Services”) under the terms of the 42Monks Business Terms or other agreement between Customer and 42Monks governing Customer’s use of the Services (the “Agreement”) 
                          and is hereby incorporated into the Agreement. If and to the extent language in this DPA conflicts with the Agreement, the conflicting terms in this DPA shall control. 
                          Capitalized terms not defined in this DPA have the meaning set forth in the Agreement. 
                          For the purposes of this DPA only, “Customer” includes any affiliate entity of Customer’s that (a) has entered into an Order Form with 42Monks and that (b) directly or indirectly, 
                          through one or more intermediaries controls, is controlled by, or is under common control with Customer.<br/><br/>

For the purposes of this DPA, “42Monks” refers to the 42Monks entity contracting with Customer. 
42Monks and Customer each agree to comply with their respective obligations under applicable data privacy and data protection laws (collectively, “Data Protection Laws”) in connection with the Services. 
Data Protection Laws may include, depending on the circumstances: the United Kingdom and/or European Union General Data Protection Regulation (Regulation (EU) 2016/679) (collectively the “GDPR”), and applicable subordinate legislation and regulations implementing those laws.<br/><br/>

In connection with the Agreement, Customer is the person that determines the purposes and means for which Customer Data (as defined below) is processed (a “Data Controller”), whereas 42Monks processes Customer Data in accordance with the Data Controller’s instructions and on 
behalf of the Data Controller (as a “Data Processor”). “Data Controller” and “Data Processor” also mean the equivalent concepts under Data Protection Laws. 
For the purposes of the Agreement and this DPA, (i) “Personal Data” has the meaning assigned to the term “personal data” or “personal information” under applicable Data Protection Laws; 
and (ii) “Customer Data” means Personal Data that Customer provides to 42Monks that 42Monks processes on behalf of Customer to provide the Services. 
42Monks will process Customer Data as Customer’s Data Processor to provide or maintain the Services and for the purposes set forth in this DPA, the Agreement and/or in any other applicable agreements between Customer and 42Monks.<br/><br/>

<b>Processing Requirements.</b><br/>
As a Data Processor, 42Monks agrees to:<br/><br/>

a. process Customer Data only (i) on Customer’s behalf for the purpose of providing and supporting 42Monks Services (including to provide insights, reporting, analytics, and platform abuse, trust and safety monitoring); 
(ii) in compliance with the written instructions received from Customer; and (iii) in a manner that provides no less than the level of privacy protection required of it by Data Protection Laws;<br/>

b. promptly inform Customer in writing if 42Monks cannot comply with the requirements of this DPA;<br/>

c. not provide Customer with remuneration in exchange for Customer Data from Customer. The parties acknowledge and agree that Customer has not “sold” (as such term is defined by the CCPA) Customer Data to 42Monks;<br/>

d. not “sell” or “share” Personal Data;<br/>

e. inform Customer promptly if, in 42Monks opinion, an instruction from Customer violates applicable Data Protection Laws;<br/>

f. require (i) persons employed by it and (ii) other persons engaged to perform on 42Monks behalf to be subject to a duty of confidentiality with respect to the Customer Data and to comply with the data protection obligations applicable to 42Monks under the Agreement and this DPA;<br/>

g. upon reasonable request no more than once per year, provide Customer with 42Monks privacy and security policies and other such information necessary to demonstrate compliance with the obligations set forth in this DPA and applicable Data Protection Laws;<br/>

h. where required by law and upon reasonable notice and appropriate confidentiality agreements, cooperate with assessments, audits, or other steps performed by or on behalf of Customer at Customer’s sole expense and in a manner 
that is minimally disruptive to 42Monks business that are necessary to confirm that 42Monks is processing Customer Data in a manner consistent with this DPA. 
Where permitted by law, 42Monks may instead make available to Customer a summary of the results of a third-party audit or certification reports relevant to 42Monks compliance with this DPA. 
Such results, and/or the results of any such assessments, audits, or other steps shall be the Confidential Information of 42Monks;<br/>

i. to the extent that Customer permits or instructs 42Monks to process Customer Data subject to EU Privacy Laws in a de-identified, anonymized, and/or aggregated form as part of the Services, 
42Monks shall (i) adopt reasonable measures to prevent such deidentified data from being used to infer information about, or otherwise being linked to, a particular natural person or 
household; (ii) not attempt to re-identify the information, except that 42Monks may attempt to reidentify the information solely for the purpose of determining whether 
its de-identification processes comply with Data Protection Laws or are functioning as intended; 
and (iii) before sharing de-identified data with any other party, including Subprocessors, contractually obligate any such recipients to comply with the requirements of this provision;<br/>

j. where the Customer Data is subject to the CCPA, not (i) retain, use, disclose, or otherwise process Customer Data except as necessary for the business purposes 
specified in the Agreement or this DPA; (ii) retain, use, disclose, or otherwise process Customer Data in any manner outside of the direct business relationship between 42Monks and 
Customer; or (iii) combine any Customer Data with Personal Data that 42Monks receives from or on behalf of any other third party or collects from 42Monks own interactions 
with individuals, provided that 42Monks may so combine Customer Data for a purpose permitted under the CCPA if directed to do so by Customer or as otherwise permitted by the CCPA;<br/>

k. where required by law, grant Customer the rights to (i) take reasonable and appropriate steps to ensure that 42Monks uses Customer Data in a manner consistent with Data Protection Laws by exercising the audit provisions 
set forth in this DPA above; and (ii) stop and remediate unauthorized use of Customer Data, for example by requesting that 42Monks provide written confirmation that applicable Customer Data has been deleted.<br/><br/>

<b>Notice to Customer.</b><br/>
42Monks will inform Customer if 42Monks becomes aware of:<br/><br/>

a. any legally binding request for disclosure of Customer Data by a law enforcement authority, 
unless 42Monks is otherwise forbidden by law to inform Customer, for example to preserve the confidentiality of an investigation by law enforcement authorities;<br/>

b. any notice, inquiry or investigation by an independent public authority established by a member state pursuant to Article 51 of the GDPR (a “Supervisory Authority”) with respect to Customer Data; or<br/>

c. any complaint or request (in particular, requests for access to, rectification or blocking of Customer Data) received directly from Customer’s data subjects. 
42Monks will not respond to any such request without Customer’s prior written authorization.<br/><br/>

<b>Assistance to Customer.</b><br/>
42Monks will provide reasonable assistance to Customer regarding:<br/><br/>

a. information necessary, taking into account the nature of the processing, to respond to requests received pursuant to Data Protection Laws from Customer’s data subjects in respect of access to or the rectification, 
erasure, restriction, portability, objection, blocking or deletion of Customer Data that 42Monks processes for Customer. 
In the event that a data subject sends such a request directly to 42Monks, 42Monks will promptly send such request to Customer;<br/>

b. the investigation of any breach of 42Monks security leading to the accidental or unlawful destruction, loss, alteration, unauthorized disclosure of, or unauthorized access to Customer Data processed by 42Monks for Customer (a “Personal Data Breach”); and<br/>

c. where appropriate, the preparation of data protection impact assessments with respect to the processing of Customer Data by 42Monks and, where necessary, carrying out consultations with any supervisory authority with jurisdiction over such processing.<br/><br/>

<b>Required Processing.</b><br/>
If 42Monks is required by Data Protection Laws to process any Customer Data for a reason other than in connection with the Agreement, 42Monks will inform Customer of this requirement in advance of any such processing, unless legally prohibited.<br/><br/>

<b>Security.</b><br/>
42Monks will:<br/><br/>

a. maintain reasonable and appropriate organizational and technical security measures to protect against unauthorized or accidental access, loss, alteration, disclosure or destruction of Customer Data and to protect the rights of the subjects of that Customer Data;<br/>

b. take appropriate steps to confirm that 42Monks personnel are protecting the security, privacy and confidentiality of Customer Data consistent with the requirements of this DPA; and<br/>

c. notify Customer of any Personal Data Breach by 42Monks, its Subprocessors, or any other third parties acting on 42Monks behalf without undue delay after 42Monks becomes aware of such Personal Data Breach.<br/><br/>

<b>Obligations of Customer.</b><br/><br/>
a. Customer represents, warrants and covenants that it has and shall maintain throughout the term all necessary rights, consents and authorizations to provide the Customer Data to 
42Monks and to authorize 42Monks to use, disclose, retain and otherwise process Customer Data as contemplated by this DPA, the Agreement and/or other processing instructions provided to 42Monks.<br/>

b. Customer shall comply with all applicable Data Protection Laws.<br/>

c. Customer shall reasonably cooperate with 42Monks to assist 42Monks in performing any of its obligations with regard to any requests from Customer’s data subjects.<br/>

d. Without prejudice to 42Monks security obligations in Security Section of this DPA, Customer acknowledges and agrees that it, rather than 42Monks, 
is responsible for certain configurations and design decisions for the services and that Customer, and not 42Monks, 
is responsible for implementing those configurations and design decisions in a secure manner that complies with applicable Data Protection Laws.<br/>

e. Customer shall not provide Customer Data to 42Monks except through agreed mechanisms. 
For example, Customer shall not include Customer Data other than technical contact information, or in technical support tickets, 
transmit user Customer Data to 42Monks by email. Without limitation to the foregoing, 
Customer represents, warrants and covenants that it shall only transfer Customer Data to 42Monks using secure, 
reasonable and appropriate mechanisms, to the extent such mechanisms are within Customer’s control.<br/>

f. Customer shall not take any action that would (i) render the provision of Customer Data to 42Monks a “sale” under EU Privacy Laws or a “share” or (ii) render 42Monks not a “service provider” or “processor” under EU Privacy Laws.<br/><br/>

<b>Term; Data Return and Deletion.</b><br/>
This DPA shall remain in effect as long as 42Monks carries out Customer Data processing operations on Customer’s behalf or until the termination of the Agreement 
(and all Customer Data has been returned or deleted in accordance with this DPA). 42Monks will retain API Service Customer Data sent through the API for a maximum of thirty (30) days, 
after which it will be deleted, except where 42Monks is required to retain copies under applicable laws, in which case 42Monks will isolate and protect 
that Customer Data from any further processing except to the extent required by applicable laws. 
42Monks will retain Enterprise Service Customer Data during the term of the Agreement, unless otherwise stated in the Agreement. 
On the termination of the DPA, 42Monks will direct each Subprocessor to delete the Customer Data within thirty (30) days of the DPA’s termination, 
unless prohibited by law. For clarity, 42Monks may continue to process information derived from Customer Data that has been deidentified, 
anonymized, and/or aggregated such that the data is no longer considered Personal Data under applicable Data Protection Laws and in a manner that does not identify individuals or 
Customer to improve 42Monks systems and services.<br/><br/>



                        </span>
                  </v-row>
                </div>
              </v-row>




            <v-row class="textPanel page-top pb-8">
                <div class="container">
                  <v-divider class="divider ml-9 mr-9 hidden-xs" style="color:black!important;"></v-divider>
                  <v-divider class="dividerxs ml-9 mr-9 hidden-sm-and-up" style="color:black!important;"></v-divider>
                </div>
            </v-row>
            <v-row class="textPanel pb-8">
                <div class="container">
                  <v-row justify="start" class="pl-12 pr-12 hidden-xs">
                    <v-col cols="6" class="pa-0 ma-0">                  
                      <h1 class="font2-heada" style="color:black!important;">Business terms</h1>
                    </v-col>
                    <v-col cols="6" justify="start" class="pa-0 ma-0">  
                      <v-row class="pl-6 pt-5">
                        <span class="mt-0 pb-0 mb-0 fonts-desc" style="color:black!important;">
                          These 42Monks Business Terms govern use of our APIs, Enterprise, and other services for businesses and developers.        
                        </span>
                      </v-row>          
                    </v-col>
                  </v-row>
                  <v-row justify="start" class="pl-12 pr-12 hidden-sm-and-up pt-0 mt-0">
                        <h1 class="font2-heada" style="color:black!important;">Business terms</h1>
                  </v-row>
                      <v-row justify="start" class="pl-12 pr-12 pt-4 pb-4 hidden-sm-and-up pt-0 mt-0">
                        <span class="mt-0 pb-0 mb-0 pl-0 fonts-desc" style="color:black!important;">
                          These 42Monks Business Terms govern use of our APIs, Enterprise, and other services for businesses and developers.                         
                        </span>
                      </v-row>   
                </div>
            </v-row>
            <v-row class="textPanel page-top pb-8">
                <div class="container">
                  <v-row justify="start" class="pl-12 pr-12 pt-8 mt-0">
                        <span class="mt-0 pb-0 mb-0 pt-6 fonts-xsmall2" style="color:black!important;">

                          These Business Terms are an agreement between 42Monks and you (“Customer”) that governs your use of our Services (as defined below). 
                          By signing up to use the Services, you agree to be bound by these Business Terms. You represent to us that you are lawfully able to enter into contracts and, if you are entering into these Business Terms for an entity, 
                          that you have legal authority to bind that entity. These Business Terms also refer to and incorporate the Service Terms, Sharing & Publication Policy, Usage Policies, and any other guidelines or policies we may provide 
                          in writing (the “42Monks Policies”) and any ordering document signed by you and 42Monks or 42Monks webpage that you use to purchase the Services (an “Order Form”) (collectively, the “Agreement”).<br/><br/>

<b>Services.</b><br/>
Use of Services. We grant you a non-exclusive right to access and use the Services during the Term (as defined below). 
This includes the right to use 42Monks application programming interfaces (“APIs”) to integrate the Services into your applications, 
products, or services (each a “Customer Application”) and to make Customer Applications available to End Users (as defined below). 
“Services” means any services for businesses and developers we make available for purchase or use, along with any of our associated software, tools, developer services, documentation, and websites, but excluding any Third Party Offering.<br/><br/>

Third-Party Offering. Third parties may offer products, services, or content through the Services (“Third Party Offering”). If you elect, in your sole discretion, 
to access or use a Third Party Offering (including by making it available via a Customer Application), your access and use of the Third Party Offering is subject to this 
Agreement and any additional terms applicable to the Third Party Offering.<br/><br/>

Responsibilities for Your Account. You must provide accurate and up-to-date account information. 
You are responsible for all activities that occur under your account, including the activities of any end user (each, an “End User”) who is provisioned with an account 
under your account (an “End User Account”) or accesses the Services through your Customer Application. 
You may not make account access credentials available to third parties, share individual login credentials between multiple users on an account, or resell or lease access to your account or any End User Account. 
You will promptly notify us if you become aware of any unauthorized access to or use of your account or our Services.<br/><br/>

<b>Restrictions.</b><br/>
We own all right, title, and interest in and to the Services. You only receive rights to use the Services as explicitly granted in this Agreement. You will not, and will not permit End Users to:<br/><br/>

(a) use the Services or Customer Content (as defined below) in a manner that violates any applicable laws or 42Monks Policies;<br/>

(b) use the Services or Customer Content in a manner that infringes, misappropriates, or otherwise violates any third party’s rights;<br/>

(c) send us any personal information of children under 13 or the applicable age of digital consent or allow minors to use our Services without consent from their parent or guardian;<br/>

(d) reverse assemble, reverse compile, decompile, translate, engage in model extraction or stealing attacks, or otherwise attempt to discover the source code or underlying components 
of the Services, algorithms, and systems of the Services (except to the extent these restrictions are contrary to applicable law);<br/>

(e) use Output (as defined below) to develop any artificial intelligence models that compete with our products and services. 
However, you can use Output to (i) develop artificial intelligence models primarily intended to categorize, classify, or organize data 
(e.g., embeddings or classifiers), as long as such models are not distributed or made commercially available to third parties and (ii) fine tune models provided as part of our Services;<br/>

(f) use any method to extract data from the Services other than as permitted through the APIs; or<br/>

(g) buy, sell, or transfer API keys from, to or with a third party.<br/><br/>

<b>Content.</b><br/>
Customer Content. You and End Users may provide input to the Services (“Input”), 
and receive output from the Services based on the Input (“Output”). We call Input and Output together “Customer Content.” As between you and 42Monks, and to the extent permitted by applicable law, 
you (a) retain all ownership rights in Input and (b) own all Output. We hereby assign to you all our right, title, and interest, if any, in and to Output.<br/><br/>

Our Obligations for Customer Content. We will process and store Customer Content in accordance with our Enterprise privacy commitments. 
We will only use Customer Content as necessary to provide you with the Services, comply with applicable law, and enforce 42Monks Policies. We will not use Customer Content to develop or improve the Services.<br/><br/>

Your Obligations for Customer Content. You are responsible for all Input and represent and warrant that you have all rights, licenses, 
and permissions required to provide Input to the Services. You are solely responsible for all use of the Outputs and evaluating the Output for accuracy and appropriateness for your use case, 
including by utilizing human review as appropriate. <br/><br/>

Similarity of Output. You acknowledge that due to the nature of our Services and artificial intelligence generally, Output may not be unique and other users may receive similar content from our services.
 Responses that are requested by and generated for other users are not considered your Output. Our assignment of Output  above does not extend to other users’ output or any content delivered as part of a Third Party Offering.<br/><br/>

<b>Confidentiality.</b><br/>
Use and Nondisclosure. “Confidential Information” means any business, technical or financial information, materials, or other subject matter disclosed by one party (“Discloser”) to the other
 party (“Recipient”) that is identified as confidential at the time of disclosure or should be reasonably understood by Recipient to be confidential under the circumstances. 
 For the avoidance of doubt, Confidential Information includes Customer Content. Recipient agrees it will: (a) only use Discloser's Confidential Information to exercise its 
 rights and fulfill its obligations under this Agreement, (b) take reasonable measures to protect the Confidential Information, and (c) not disclose the Confidential Information to any third party except as expressly permitted in this Agreement.<br/><br/>

Exceptions. The obligations do not apply to any information that (a) is or becomes generally available to the public through no fault of Recipient,
 (b) was in Recipient’s possession or known by it prior to receipt from Discloser, (c) was rightfully disclosed to Recipient without restriction by a
  third party, or (d) was independently developed without use of Discloser’s Confidential Information. 
  Recipient may disclose Confidential Information only to its employees, contractors, and agents who have a need to know and who are bound by confidentiality 
  obligations at least as restrictive as those of this Agreement. Recipient will be responsible for any breach of this Section by its employees, contractors, and agents. 
  Recipient may disclose Confidential Information to the extent required by law, provided that Recipient uses reasonable efforts to notify Discloser in advance.<br/><br/>

<b>Privacy.</b><br/>
Personal Data. If you use the Services to process personal data, you must (a) provide legally adequate privacy notices and obtain necessary consents for the processing of 
personal data by the Services, (b) process personal data in accordance with applicable law, and (c) if processing “personal data” or 
“Personal Information” as defined under applicable data protection laws, execute our Data Processing Addendum by filling out this form.<br/><br/>

HIPAA. You agree not to use the Services to create, receive, maintain, transmit, or otherwise process any information that includes or constitutes “Protected Health Information”, as defined under the HIPAA Privacy Rule (45 C.F.R. Section 160.103), 
unless you have signed a Healthcare Addendum and Business Associate Agreement (together, the “Healthcare Addendum”) with us prior to creating, receiving, maintaining, transmitting, or otherwise processing this information.<br/><br/>

<b>Payment; Taxes.</b><br/>
Fees and Billing. You agree to pay all fees charged to your account (“Fees”) according to the prices and terms on the Pricing Page, 
or as otherwise stated in an Order Form. Price changes on the Pricing Page will be effective immediately for all price decreases or changes made for legal reasons. 
All other price changes will be effective 14 days after they are posted. We have the right to correct pricing errors or mistakes even after issuing an invoice or receiving payment. 
You authorize us and our third-party payment processor(s) to charge the payment method provided on your account on an agreed-upon periodic basis, 
but we may reasonably change the date on which the charge is posted. Fees are payable in euros and are due upon invoice issuance, unless 
otherwise agreed in an Order Form. Payments are nonrefundable except as provided in this Agreement.<br/><br/>

Service Credits. You may need to prepay for Services through the purchase of credits (“Service Credits”) or we may provide you with promotional Service Credits from time-to-time. All Service Credits are subject to our Service Credit Terms.<br/><br/>

Taxes. Fees are exclusive of taxes, which we will charge as required by applicable law in connection with the Services. We will use the name and address in your account as the place of supply for tax purposes. <br/><br/>

Disputes and Late Payments. To dispute an invoice, you must contact us within thirty (30) days of issuance. Overdue undisputed amounts may be subject to a finance charge of 1.5% of the unpaid balance per month, 
and we may suspend the Services immediately after providing written notice of late payment.<br/><br/>

<b>Term; Termination.</b><br/>
Term. The term of this Agreement will commence upon the earlier of your online acceptance of these Business Terms, the Effective Date of an Order Form, 
or the date you first use the Services, and will remain in effect until terminated pursuant to this Section (“Term”). If you purchase a subscription to the Services, 
the subscription term will automatically renew for successive periods unless either of us gives the other notice of its intent not to renew. 
That notice must be given at least thirty days before the start of the next renewal period. <br/><br/>

Termination. Unless you purchase Services for a committed duration, you may terminate this Agreement at any time by deleting your account. 
Both you and 42Monks may terminate this Agreement upon written notice (a) if the other party materially breaches this Agreement and does not cure the breach within thirty (30) 
days after receiving written notice of the breach or (b) if the other party ceases its business operations or becomes subject to insolvency proceedings. 
We may suspend your or any End User’s access to the Services or terminate this Agreement or any Order Form: (i) if required to do so by law; (ii) to prevent a 
security risk or other credible risk of harm or liability to us, the Services, or any third party; or (iii) for repeated or material violations of the 42Monks Policies.
 We will use reasonable efforts to notify you of any suspension or termination and give you the opportunity to resolve the issue prior to suspension or termination. <br/><br/>

Effect of Termination. Termination or expiration will not affect any rights or obligations, 
including the payment of amounts due, which have accrued under this Agreement up to the date of termination or expiration. 
Upon termination or expiration of this Agreement, the provisions that are intended by their nature to survive termination will survive and continue in full 
force and effect in accordance with their terms, including confidentiality obligations, limitations of liability, and disclaimers. 
Upon termination of this Agreement, we will delete all Customer Content from our systems within 30 days, unless we are legally required to retain it.<br/><br/>

<b>Warranties; Disclaimer.</b><br/>
Warranties. We warrant that, during the Term, when used in accordance with this Agreement, the Services will conform in all material respects with the documentation we provide to you or otherwise make publicly available.<br/><br/>

Disclaimer. Except for the warranties in this Section, the Services are provided “as is” and we and our affiliates and licensors hereby disclaim all warranties, 
express or implied, including all implied warranties of merchantability, fitness for a particular purpose and title, noninfringement, or quiet enjoyment, 
and any warranties arising out of course of dealing or trade usage. Despite anything to the contrary, we make no representations or warranties (a) that use of the Services will 
be uninterrupted, error free, or secure, (b) that defects will be corrected, (c) that Customer Content will be accurate, or (d) with respect to Third Party Offerings.<br/><br/>

<b>Indemnification.</b><br/>
By Us. We agree to defend and indemnify you for any damages finally awarded by a court of competent jurisdiction and any settlement amounts payable to a third party arising out of a third party claim 
alleging that the Services (including training data we use to train a model that powers the Services) infringe any third party intellectual property right. 
This excludes claims to the extent arising from: (a) combination of any Services with products, services, or software not provided by us or on our behalf, 
(b) fine-tuning, customization, or modification of the Services by any party other than us, 
(c) the Input or any training data you provide to us, 
(d) your failure to comply with this Agreement or laws, regulations, or industry standards applicable to you, or 
(e) Customer Applications (if the claim would not have arisen but for your Customer Application). <br/><br/>
If we reasonably believes that all or any portion of the Services  is likely to become the subject of any infringement claim, we 
(x) will procure, at our expense, the right for you to continue using the Services in accordance with this Agreement, 
(y) will replace or modify the allegedly infringing Service so it is non-infringing, or (z), if (x) and (y) 
are not commercially practicable, we may, in our sole discretion, terminate this Agreement upon written notice to you and refund any prepaid amounts for unused Services. 
You will promptly comply with all reasonable instructions we provide you with respect to (x) through (y) above, including any instruction to replace, modify, or cease use of an impacted Service.<br/><br/>

By Customer. You agree to indemnify, defend, and hold us and our affiliates and licensors harmless against any liabilities, damages, and costs (including reasonable attorneys’ fees) payable to a third party 
arising out of a third party claim related to (a) use of the Services in violation of this Agreement (including violation of 42Monks Policies), 
(b) Customer Applications (if any), or (c) Input.<br/><br/>

Indemnification Procedure. A party seeking indemnity will provide the indemnifying party with prompt written notice upon becoming aware of any claim, 
reasonable cooperation in the defense of or investigation of the claim (including preserving and sharing the applicable Customer Content), 
and allow the indemnifying party sole control of defense and settlement of the claim, provided that the party seeking indemnity is entitled 
to participate in its own defense at its sole expense. The indemnifying party cannot enter into any settlement or compromise of any claim without 
prior written consent of the other party, which will not be unreasonably withheld, except that the indemnifying party may without consent enter into any 
settlement of a claim that resolves the claim without liability to the other party, impairment to any of the other party’s rights, or requiring the other party to make any admission of liability. 
<br/><br/>THE REMEDIES IN THIS SECTION ARE THE SOLE AND EXCLUSIVE REMEDIES FOR ANY THIRD PARTY CLAIM THAT THE SERVICES OR CUSTOMER CONTENT INFRINGE INTELLECTUAL PROPERTY RIGHTS.<br/><br/>

<b>Limitation of Liability.</b><br/>
Limitations on Indirect Damages. Except for (i) a party’s gross negligence or willful misconduct, 
(ii) your breach of Restrictions, (iii) either party’s breach of its confidentiality obligations under Confidentiality, 
(iv) our breach of a party’s indemnification obligations under this Agreement, neither you nor 42Monks or our respective affiliates 
or licensors will be liable under this Agreement for any indirect, punitive, incidental, special, consequential, or exemplary damages (including lost profits) even if that party has been advised of the possibility of those damages.<br/><br/>

Liability Cap. Except for (i) a party’s gross negligence or willful misconduct or (ii) a party’s indemnification obligations under this Agreement, 
each party’s total liability under the Agreement will not exceed the total amount you have paid to us in the 
twelve (12) months immediately prior to the event giving rise to liability. 
The foregoing limitations will apply despite any failure of essential purpose of any limited remedy and to the maximum extent permitted under applicable law.<br/><br/>

<b>Modifications to these Business Terms and the 42Monks Policies.</b><br/>
Updates. We may update these Business Terms or the 42Monks Policies by providing you with reasonable notice, including by posting the update on our website. 
If, in our sole judgment, an update materially impacts your rights or obligations, we will provide at least 30 days’ notice before the update goes into effect, 
unless the update is necessary for us to comply with applicable law, in which case we will provide you with as much notice as reasonably possible. 
Any other updates will be effective on the date we post the updated Business Terms or 42Monks Policies. 
Your continued use of, or access to, the Services after an update goes into effect will constitute acceptance of the update. 
If you do not agree with an update, you may stop using the Services or terminate this Agreement.<br/><br/> 

Exceptions to Updates. Except for an update to comply with applicable law, updates to these Business Terms or the 42Monks Policies will not apply to: 
(a) Disputes between you and 42Monks arising prior to the update; or (b) Order Forms signed by you and 42Monks (as opposed to an automated ordering page)
 prior to us notifying you of the update. However, to the extent an update relates to a Service or feature launched after an Order Form is signed it will be effective upon your first use of such Service.<br/><br/>




                        </span>
                  </v-row>
                </div>
              </v-row>




            <v-row class="textPanel page-top pb-8">
                <div class="container">
                  <v-divider class="divider ml-9 mr-9 hidden-xs" style="color:black!important;"></v-divider>
                  <v-divider class="dividerxs ml-9 mr-9 hidden-sm-and-up" style="color:black!important;"></v-divider>
                </div>
            </v-row>


            
            <v-row class="textPanel pb-8">
                <div class="container">
                  <v-row justify="start" class="pl-12 pr-12 hidden-xs">
                    <v-col cols="6" class="pa-0 ma-0">                  
                      <h1 class="font2-heada" style="color:black!important;">Service credit terms</h1>
                    </v-col>
                    <v-col cols="6" justify="start" class="pa-0 ma-0">  
                      <v-row class="pl-6 pt-5">
                        <span class="mt-0 pb-0 mb-0 fonts-desc" style="color:black!important;">
                         These terms govern any credits redeemable for our services.             
                        </span>
                      </v-row>          
                    </v-col>
                  </v-row>
                  <v-row justify="start" class="pl-12 pr-12 hidden-sm-and-up pt-0 mt-0">
                        <h1 class="font2-heada" style="color:black!important;">Service credit terms</h1>
                  </v-row>
                      <v-row justify="start" class="pl-12 pr-12 pt-4 pb-4 hidden-sm-and-up pt-0 mt-0">
                        <span class="mt-0 pb-0 mb-0 pl-0 fonts-desc" style="color:black!important;">
                          These terms govern any credits redeemable for our services.                       
                        </span>
                      </v-row>   
                </div>
            </v-row>
            <v-row class="textPanel page-top pb-14">
                <div class="container">
                  <v-row justify="start" class="pl-12 pr-12 pt-8 mt-0">
                        <span class="mt-0 pb-0 mb-0 pt-6 fonts-xsmall2" style="color:black!important;">
                          These 42Monks Service Credit Terms (“Terms”) are an agreement between you and 42Monks and govern your purchase, receipt, or use of any credit redeemable for our Services (“Service Credit”). 
                          Capitalized terms used but not defined in these Terms will have the meanings set forth in the agreement between you and 42Monks governing your use of the applicable Services (the “Agreement”).<br/><br/>

We may offer the option to prepay for certain Services through the purchase of credits (“Prepaid Service Credits”). Prepaid Service Credits represent the amount you have paid in advance for use of the respective Services. Additional terms may apply to specific Services.<br/><br/>
We may also offer Service Credits free of charge as part of a promotional program rather than for purchase (“Promo Service Credits”). Promo Service Credits will not be applied against any sales, use, gross receipts, or similar transaction based taxes that may be applicable to you.<br/><br/>
Service Credits are not legal tender or currency; are not redeemable, refundable, or exchangeable for any sum of money or monetary value; have no equivalent value in fiat currency; do not act as a substitute for fiat currency;
 and do not constitute or confer upon you any personal property right. <br/><br/>
All sales of Services, including sales of prepaid Services, are final. Service Credits are not refundable.<br/><br/>
Your available Service Credit balance may be reviewed in your 42Monks account. You are solely responsible for verifying that the proper amount of Service Credits has been added to or deducted from your balance. 
Your Service Credit balance is not a bank account, digital wallet, stored value account, or other payment device.<br/><br/>
We prohibit and do not recognize any purported transfers, sales, gifts, or trades of Service Credits.<br/><br/>
We reserve the right to suspend or terminate your use of the Services in accordance with the Agreement, including suspending or terminating your Service Credit balance, in compliance with applicable law.<br/><br/>
We may modify these Terms at any time by posting a revised version on our website or by emailing the email associated with your account. The modified Terms will become effective upon posting or, if we notify you by email, as stated in the email message. 
By receiving or using any Service Credit after the effective date of any modification to these Terms, you agree to be bound by the modified Terms.<br/><br/>


                        </span>
                  </v-row>
                </div>
              </v-row>


      </div>
          <div class="body-overall fonts">
            <v-row class="textPanel pb-0">
              <v-divider class="divider ml-9 mr-9 hidden-xs mt-14" style="color: black!important;"></v-divider>
              <v-divider class="dividerxs ml-9 mr-9 hidden-sm-and-up mt-14" style="color: black!important;"></v-divider>
            </v-row>
          </div>
      <div class="body-overall fonts">
          <Footer typed="finance"></Footer>
      </div>
    </div>
  </div>
</template>

<script>
import NavBar from './NavBar'
import Footer from './Footer'

export default {
  name: 'Terms',
  props: ['drawerham'],

  components: {
    NavBar,
    Footer
  },
  data: () => ({
    videoHeight: 1000 // Initial height of the video
  }),
  mounted() {  
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  destroyed() {
  },
  computed: {

  },  
  created() {

  }, 
  methods: {
    handleScroll() {
      if (!this.drawerham){
        // Get the current scroll position
        const scrollPosition = Math.round(window.scrollY || window.pageYOffset);
        // Calculate the new height for the video
        const newVideoHeight = Math.round(Math.max(500, 1000 - scrollPosition));
        // Update the video height
        this.videoHeight = newVideoHeight;
      }
    },
    handleClickVideo(link){
      if (link === 'Log') {
        window.open('https://selene.42monks.com/','_blank');
      } else if (link === 'Office') {
        window.open('https://office.42monks.com/','_blank');
      } else {
        if (this.$route.name !== link ) {
          this.$router.push({ name: link });
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>

@use './css/styles.scss';
@use './css/styles_finance.scss';

:deep(.v-btn:hover)>.v-btn__overlay {
  --v-hover-opacity: 0;
  opacity: 0;
}

:deep(.v-btn[aria-haspopup=menu][aria-expanded=true])>.v-btn__overlay {
  --v-hover-opacity: 0;
  opacity: 0;
}

:deep(.v-btn[aria-haspopup=menu][aria-expanded=true]:hover)>.v-btn__overlay {
  --v-hover-opacity: 0;
  opacity: 0;
}

:deep(.v-list-item:hover)>.v-list-item__overlay {
  --v-hover-opacity: 0;
  opacity: 0;
}

:deep(.v-list-item__append){
  display: inline-block;
}

#videoContainerEmpty {
  position: relative;
  box-sizing: border-box;
  max-height: 100px;
  transition: height 0.10s linear;
}

#videoContent {
  position: sticky;
  top: 0;
  max-height: 100px;
  transition: height 0.10s linear;
}

#bkgrdVideoOverlay {
  position: absolute;
  top:0;
  left:0;
  width: 100%;
  max-height: 100px;
  object-fit: cover; 
  background-color: #00000000; 
  z-index: 5;
  transition: height 0.10s linear;
}

.body-overall {
  background-color: white !important;
  margin: 0; /* Remove default margin */
  padding: 0; /* Remove default padding */
  z-index: 3;
}


.nomenu-btn-page {
  color: black;
  font-family: "Darker Grotesque", sans-serif;
  font-weight: 500;
  font-size: 20px;
  transition: none !important;
  box-shadow: none !important;
  background-color: transparent !important;
  margin-left: 10px;
  padding-left: 2px;
  margin-right: 10px;
  padding-right: 2px;
}

.nomenu-btn-page.active,
.nomenu-btn-page:hover {
  color: black;
  background-color: transparent !important;
  transition: none;
}

.nomenu-btn-page::before {
  content: "";
  position: absolute;
  left: 4px;
  top: 30px;
  width: 92%; /* Spread the line over the text and icon */
  height: 1px; /* Line thickness */
  background-color: black; /* Color of the underline */
  opacity: 1; /* Initially hide the underline */
}

.nomenu-btn-page.active::before,
.nomenu-btn-page:hover::before {
  opacity: 0.3; /* Show the underline when hovering */
}

.nomenu-btn-link {
  color: black;
  font-family: "Darker Grotesque", sans-serif;
  font-weight: 500;
  font-size: 20px;
  transition: none !important;
  background-color: transparent !important;
  margin-left: 10px;
  padding-left: 2px;
  margin-right: 10px;
  padding-right: 2px;
}

.nomenu-btn-link.active,
.nomenu-btn-link:hover {
  color: black;
  background-color: transparent !important;
  transition: none;
}

.nomenu-btn-link::before {
  content: "";
  position: absolute;
  left: 0px;
  top: 30px;
  width: 100%; /* Spread the line over the text and icon */
  height: 1px; /* Line thickness */
  background-color: black; /* Color of the underline */
  opacity: 0; /* Initially hide the underline */
}

.nomenu-btn-link.active::before,
.nomenu-btn-link:hover::before {
  opacity: 1; /* Show the underline when hovering */
}


</style>

